<template>
  <div class="card">
    <div class="card-header padding_12_20">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="me-3">
            <img src="@/assets/images/svg-img/finance.svg" />
          </div>
          <div>
            <div class="card_title_1">ASSET EVALUATION</div>
            <div class="card_title_2">Last Updated {{ last_update }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-4">
          <select v-model="uuid" class="custom-dropdown form-select">
            <option
              v-for="(option, key) in dataUuid"
              :key="key"
              :value="option.value"
              :disabled="option.disabled"
            >
              {{ option.label }}
            </option>
          </select>
        </div>
        <div class="col-4">
          <select v-model="unit" class="custom-dropdown form-select">
            <option
              v-for="(option, key) in dataUnit"
              :key="key"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </div>
        <div class="col-4">
          <select v-model="upul" class="custom-dropdown form-select">
            <option
              v-for="(option, key) in dataUpul"
              :key="key"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>
      <div
        class="table-responsive"
        style="
          border: 1px solid #e5e7ed;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          margin-top: 20px;
        "
      >
        <table class="table">
          <thead
            style="
              font-size: 12px;
              font-weight: 400;
              line-height: 14.06px;
              letter-spacing: 0.02em;
              --bs-table-bg: #f0f0f0;
            "
          >
            <tr>
              <th width="40%" scope="col" rowspan="2">Asset Type</th>
              <th scope="col" colspan="2" style="text-align: center">
                Replacement Needed
              </th>
            </tr>
            <tr>
              <th width="30%" scope="col" style="text-align: center">
                Old Assets
              </th>
              <th width="30%" scope="col" style="text-align: center">
                Broken Assets
              </th>
            </tr>
          </thead>
        </table>
      </div>
      <div
        class="table-responsive"
        style="height: 500px; overflow-y: scroll; border: 1px solid #e5e7ed"
      >
        <table class="table">
          <tbody
            style="
              font-size: 14px;
              font-weight: 400;
              line-height: 16.41px;
              letter-spacing: 0.02em;
            "
          >
            <tr
              v-for="(asset, key) of assetEvaluation"
              :class="
                key >= Object.keys(assetEvaluation).length - 1 ? 'hidden' : ''
              "
            >
              <td width="40%">{{ asset.name }}</td>
              <td width="30%" style="text-align: center">
                {{ formattedNumber(asset.old) }}
              </td>
              <td width="30%" style="text-align: center">
                {{ formattedNumber(asset.broken) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="table-responsive"
        style="
          border: 1px solid #e5e7ed;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        "
      >
        <table class="table">
          <thead
            style="
              font-size: 14px;
              font-weight: 400;
              line-height: 16.41px;
              letter-spacing: 0.02em;
            "
          >
            <tr>
              <th width="40%">{{ this.rowTotal.name }}</th>
              <th width="30%" style="text-align: center">
                {{ formattedNumber(this.rowTotal.old) }}
              </th>
              <th width="30%" style="text-align: center">
                {{ formattedNumber(this.rowTotal.broken) }}
              </th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import DistributionService from "@/services/distribution/distribution";
import ReferenceService from "@/services/reference/reference";
import { formattedNumber } from "@/utils/helper";

const apiDistribution = DistributionService.build();
const getRef = ReferenceService.build();

export default {
  data() {
    return {
      props: ["last_update"],
      assetEvaluation: [],
      rowTotal: {},
      dataLoaded: false,
      uuid: "default",
      dataUuid: [],
      unit: "default",
      dataUnit: [],
      upul: "default",
      dataUpul: [],
    };
  },
  mounted() {
    this.getDataDistributionAssetEvaluation("");
    this.getRefUid();
    this.getRefUnit();
    // this.getRefUpUl();
  },
  watch: {
    uuid() {
      this.getRefUpUl(this.uuid);
    },
  },
  methods: {
    async getRefUnit() {
      const res = await getRef.getRefMaterial();
      const data = res.data.data;
      const defaults = { label: "Type of Unit", value: "default" };
      const filter = data.map((project) => ({
        value: project.value,
        label: project.description,
      }));
      this.dataUnit = data;
      this.dataUnit.push(defaults);
    },
    async getRefUpUl(value) {
      const param = {
        uid: value,
      };
      const res  = await getRef.getRefUpUl(param);
      const data = res.data.data;
      const defaults = { label: "Select UP/UL", value: "default" };
      this.dataUpul = data;
      this.dataUpul.push(defaults);
    },
    async getRefUid() {
      const res = await getRef.getRefUid();
      const data = res.data.data;
      const defaults = {
        label: "Select UID",
        value: "default",
        disabled: true,
      };
      this.dataUuid = data;
      this.dataUuid.push(defaults);
    },
    async getDataDistributionAssetEvaluation(instance) {
      let param = Object.assign({
        instance: instance,
      });
      const res = await apiDistribution.getDataDistributionAssetEvaluation(
        param
      );
      if (res && res.status == 200) {
        this.assetEvaluation = res.data.data;
        this.dataLoaded = true;
        this.rowTotal = this.assetEvaluation[this.assetEvaluation.length - 1];
      }
    },
    formattedNumber,
  },
};
</script>

<style>
.rowTotal {
  --bs-table-bg: #f0f0f0;
  font-size: 14px;
  font-weight: 700;
  line-height: 16.41px;
  letter-spacing: 0.02em;
}

.hidden {
  display: none;
}
</style>
